import { Tabs , Tab, Grid, TextField, Container} from '@material-ui/core';
import TabPanel  from '../../components/Tabpanel';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Preloader from '../../components/PreLoader';
import { searchStoreInterface } from '../../store/ActionReducers/search.actionreducer';
import BlogCard from '../../components/BlogCard';
import NoticeCard from '../../components/NoticeCard';
import { IoCalendar } from 'react-icons/io5';
import moment from 'moment';
import {debounce} from 'lodash';
import { ecnSearch } from '../../services/search.service';
import { lang } from '../../config/app.config';
import {Link} from 'react-router-dom';
import translates from '../../translation.json';

interface state{
  search:searchStoreInterface
}

const SearchPage:React.FC = () =>{
  const dispatch = useDispatch();

  const state = useSelector((state:state)=>{
    const {search} = state;
    return search;
  });
  
  const {
    searches,
    searching,
    keyword
  } = state;

  const [value, setValue] = React.useState('news');

  const handleSearch = debounce((e:any)=>{
    let val = e.target.value;
    if(val) dispatch(ecnSearch(val));
  },1000);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
  };

  useEffect(()=>{
    if(searches){
      if(searches?.news && searches?.news.length){
        setValue('news')
      }else if(searches?.notices && searches?.notices.length){
        setValue('notices');
      }
      else if(searches?.press_releases && searches?.press_releases.length){
        setValue('press_releases');
      }
      else if(searches?.branches && searches?.branches.length){
        setValue('election_offices');
      }
    }
  },[searches])


  

  return(
    <Container maxWidth="lg" >
    {searching?<Preloader/>:
      <div className="section-padding-2" style={{minHeight:'70vh'}}>
        <div className="section-break-1">
          <Grid container className="justify-content-center">
            <Grid item xs={12} md={6}>
              <TextField id="outlined-search" 
              onChange={e=>handleSearch(e)}
              label="Search" type="search" variant="outlined" style={{width:'100%'}} defaultValue={keyword||""}/>
            </Grid>
          </Grid>
        </div>
        {
          !searches?.news.length && !searches?.notices.length && !searches?.branches.length && !searches?.press_releases.length ?
          <h1 className="text-15-primary text-center mt-2">{keyword?`Sorry no results found for ${keyword}`:"Type something to search!"}</h1>:
        <>
          <Tabs value={value} onChange={handleChange} className='custom-tabs c2' aria-label="wrapped label tabs example" style={{backgroundColor: 'transparent'}}>
          {
            searches?.news && searches?.news.length?
            <Tab value="news" label="News"/>
          :''}

          {
            searches?.notices && searches?.notices.length?
            <Tab value="notices" label="Notices"/>
          :''}

          {
            searches?.press_releases && searches?.press_releases.length?
            <Tab value="press_releases" label="Press releases"/>
          :''}

          {
            searches?.branches && searches?.branches.length?
            <Tab value="election_offices" label="Election offices"/>
          :''}


          </Tabs>
          {
            searches?.news && searches?.news.length?
            <TabPanel value={value} index="news" bgWhite={true}>
              <Grid container spacing={3}>
                {
                  searches?.news.map(news=>(
                    <Grid item lg={4} xl={3} md={6} xs={12} key={news.id}>
                      <BlogCard news={news}/>
                    </Grid>
                  ))
                }
              </Grid>
            </TabPanel>
          :""}

          {
            searches?.notices && searches?.notices.length?
            <TabPanel value={value} index="notices" bgWhite={true}>
              <Grid container spacing={3}>
                {
                  searches?.notices.map(notice=>(
                    <Grid item xs={12} key={notice.id}>
                      <NoticeCard notice={notice}/>
                    </Grid>
                  ))
                }
              </Grid>
            </TabPanel>
          :""}


          {
            searches?.press_releases && searches?.press_releases.length?
            <TabPanel value={value} index="press_releases" bgWhite={true}>
              <Grid container spacing={3}>
                {
                  searches?.press_releases.map(pr=>(
                    <Grid item xs={12} key={pr.id}>
                      <a href={pr.value} target="_blank"  rel="noreferrer" className="text-16-primary mb-05"> 
                        <span className="mr-1 text-18-primary"> - </span><span>{pr.name}</span>
                        <p className="text-13-grey ml-2 display-flex-ac"><IoCalendar className="mr-1"/>{moment(pr.created_at).format('yyyy-MM-DD')}</p>
                      </a>
                    </Grid>
                  ))
                }
              </Grid>
            </TabPanel>
          :""}

          {
            searches?.branches && searches?.branches.length?
            <TabPanel  value={value} index="election_offices" bgWhite={true}>
              <div className="text-center">
                <h3 className="ecn-title">{translates.translation[lang].province}</h3>
              </div>
              <Grid container spacing={3}>
              {
              searches?.branches.map(b=>{
                if(!b.district){
                  return (
                    <Grid item lg={3} md={6} sm={12}>
                      <Link to={`/${lang}/province/${b.slug}`} key={b.id} className="text-primary" target="_blank">                         
                        <div className="branch-card">
                          <h4 className="text-18-primary">
                          {b.province}
                          </h4>
                        </div>
                      </Link>
                    </Grid>
                  );
                }return '';
              })
            }
            </Grid>

              <div className="text-center mt-1">
                <h3 className="ecn-title">{translates.translation[lang].districts}</h3>
              </div>
              <Grid container spacing={3}>
            {searches?.branches.map(b=>{
                if(b.district){
                  return (
                    <Grid item lg={3} md={6} sm={12}>
                      <Link to={`/${lang}/district/${b.slug}`} key={b.id} className="text-primary" target="_blank">                         
                        <div className="branch-card">
                          <h4 className="text-18-primary">
                          {b.district}
                          </h4>
                        </div>
                      </Link>
                    </Grid>
                  );
                } 
                return "";
              })
            }
            </Grid>
            </TabPanel>
          :""}

        </>
        
        }
      </div>
      
    }
    </Container>
  );
}

export default SearchPage;